import { ROUTES_TYPES } from "./routesTypes";

const {
  LOAD_ROUTES,
  SET_ROUTES,
  NEW_ROUTE,
  SET_NEW_ROUTE,
  EDIT_ROUTE,
  SET_EDITED_ROUTE,
  DELETE_ROUTE,
  CLEAR_ROUTES,
  HANDLE_ROUTES_BUILDINGS_INPUTS
} = ROUTES_TYPES;

const initialState = {
  isLoadingPage: false,
  routes: [],
  routeList: [],
  employees: [],
  station: null,

  //edit
  isAddMode: false,
  isDeleteMode: false,
  editRoute: null,

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

const toLabelElement = route => ({
  id: route.id,
  label: route.name,
  value: route.id
});

export const routesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_ROUTES_BUILDINGS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_ROUTES:
      return {
        ...state,
        isLoadingPage: true
      };

    case SET_ROUTES:
      return {
        ...state,
        isLoadingPage: false,
        routes: payload.routes,
        routeList: payload.routes.map(toLabelElement),
        employees: payload.employees
      };

    case EDIT_ROUTE:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: false,
        editRoute: payload
      };

    case NEW_ROUTE:
      return {
        ...state,
        isAddMode: true,
        isDeleteMode: false
      };

    case SET_NEW_ROUTE: {
      const newRoutes = [payload, ...state.routes];

      return {
        ...state,
        routes: newRoutes
      };
    }

    case SET_EDITED_ROUTE: {
      const newRoutes = [...state.routes];
      const indexToEdit = newRoutes.findIndex(route => route.id === payload.id);

      if (indexToEdit !== -1) {
        newRoutes[indexToEdit] = payload;
      }

      return {
        ...state,
        routes: newRoutes
      };
    }

    case DELETE_ROUTE:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: true
      };

    case CLEAR_ROUTES:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
};
